<template lang="pug">
  .dialog-container(id="DialogGroup-container")
    el-row.row()
      el-col.col-left(:span="10")
        h4 {{$t('Add screens')}}:
        hr.header
        ShortScreenList(id="DialogGroup-screensList" ref='childrenList', :items='this.$store.state.Device.desktops_selected_right', :showThumbs="true", :showMediaIcons="true")
      el-col.col-middle(:span="4")
        el-button.confirm(id="DialogGroup-addButton" v-if='!saving', type="success", @click="assignDesktopsToGroup()", circle)
          font-awesome-icon.linker-icon(icon="chalkboard-teacher")
          | &nbsp; {{$t("Add")}} &nbsp;
          font-awesome-icon.linker-icon(icon="arrow-right")
        el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
          font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
          .spinner-text {{ percentDone }}%
      el-col.col-right(:span="10")
        .groups
          h4 {{$t('to location')}}:
          hr.header
          el-select(id="DialogGroup-locationSelect" v-model='assignGroupTargetId', filterable)
            el-option(
              v-for="item in assignGroupTargets",
              :key="item.id",
              :label="item.name",
              :value="item.id",
              :id="'DialogGroup-locationOption' + item.id"
            )
          el-button(
            type="text",
            size="mini",
            id="DialogGroup-createGroupButton",
            @click="showCreateGroup = true",
          )
            span &nbsp;
            font-awesome-icon.icon(icon="plus")
    el-dialog(:close-on-click-modal="false", title='', :visible.sync='showCreateGroup', append-to-body)
      el-header {{$t('Add new device location')}}
      hr.header
      el-form.add-group-form(:mode='newGroup', ref='newGroupForm', label-width='100px')
        el-form-item(:label="$t('Name')")
          el-input(id="DialogGroup-createGroupNameInput" v-model='newGroup.name')
        el-form-item(:label="$t('Address')")
          el-input(id="DialogGroup-createGroupAddressInput" v-model='newGroup.address', type="textarea")
        el-form-item.float-right
          el-button(id="DialogGroup-createGroupSubmitButton" :disabled='newGroup.name.length === 0', type='success', size="mini", @click='createGroup()') {{$t('Add location')}}
</template>

<script>

import ShortScreenList from '../Common/ShortScreenList'
import Vue from 'vue'

export default {
  props: [],
  components: {
    ShortScreenList
  },
  created () {
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0,
      newGroup: {
        name: '',
        address: '',
        latitude: '',
        longitude: ''
      },
      assignGroupTargetId: undefined,
      showCreateGroup: false
    }
  },
  methods: {
    async createGroup () {
      const path = 'DeviceDesktopGroup/create'
      await Vue.axios
        .post(path, this.newGroup)
        .then(response => {
          this.$store.dispatch('Device/addDesktopGroup', response.data)
          this.assignGroupTargetId = response.data.id
        })
      this.showCreateGroup = false
      this.newGroup = {
        name: '',
        address: '',
        latitude: '',
        longitude: ''
      }
    },
    async assignDesktopsToGroup () {
      this.$emit('linkerJobStarted')
      this.saving = true
      const toBeDoneOperations = this.$refs.childrenList.selectedItems.length
      let doneSoFarOperations = 0
      for (const child of this.$refs.childrenList.selectedItems) {
        await this.$store.dispatch('Device/assignDesktopToGroup', [child.id, this.assignGroupTargetId])
        doneSoFarOperations++
        this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
      }
      this.$emit('linkerJobDone')
      this.saving = false
      this.percentDone = 0
    }
  },
  computed: {
    desktopPlayListsSelected () {
      const localPlayListsIdsOfSelectedDesktops = this.$store.state.Device.desktops_selected_right.map(dsr => dsr.LocalPlayList)
      return this.$store.state.Medium.media_list.filter(medium => localPlayListsIdsOfSelectedDesktops.includes(medium.id))
    },
    assignPlayListTargets () {
      return this.$store.state.Medium.media_selected_right.filter(medium => medium.type === 'PlayList' || medium.type === 'PlayListLayout')
    },
    assignGroupTargets () {
      return this.$store.state.Device.device_desktop_groups
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
.add-group-form {
  margin-bottom: 50px;
  border: 0px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogGroup.vue